import { render, staticRenderFns } from "./InlineLoader.vue?vue&type=template&id=3c3962c0&scoped=true&lang=pug"
import script from "./InlineLoader.vue?vue&type=script&lang=ts"
export * from "./InlineLoader.vue?vue&type=script&lang=ts"
import style0 from "./InlineLoader.vue?vue&type=style&index=0&id=3c3962c0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3962c0",
  null
  
)

/* custom blocks */
import block0 from "./InlineLoading.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fcomponents%2FInlineLoader%2FInlineLoader.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports